const TRACKER_DEBUG = false;

// Type is VOD/AS
function globalEventFire(eventName, type, payload={}) {
    // Fire on FB
    if(TRACKER_DEBUG) {
        console.log('Firing "track":', eventName, type, payload);
    }

    // Purchases
    if(eventName == 'Purchase') {
        // Facebook
        var fbPayload = {
            'content_ids': [type + payload.item_id],
            'content_category': payload.category,
            'content_name': payload.name,
            'content_type': 'product',
            'currency': 'GBP',
            'num_items': payload.num_items,
            'value': payload.amount,
        };

        
        // Only call fbq if it exists. It won't is cookie bot killed the external request
        if (typeof window.fbq === 'function') {
            window.fbq('track', eventName, fbPayload);
        }

        // Clear datalayer
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            'event': 'transaction',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': payload.enrolment_id,
                        'affiliation': 'Play Virtuoso',
                        'revenue': payload.amount,
                        'shipping': 0
                    },
                    'products': [ // List of productFieldObjects.
                        {
                            'name': type + ': ' + payload.name, // Name or ID is required.
                            'id': payload.item_id,
                            'price': payload.amount,
                            'brand': 'Play Virtuoso',
                            'category': payload.category,
                            'quantity': 1
                        }
                    ]
                }
            }
        });
    }

    // Subscriptions
    if(eventName == 'Subscribe') {
        // Facebook
        var fbPayload = {
            'content_ids': [type + payload.item_id],
            'content_category': payload.category,
            'content_name': payload.name,
            'content_type': 'product',
            'currency': 'GBP',
            'num_items': 1,
            'value': payload.amount,
        };

        // Only call fbq if it exists
        if (typeof window.fbq === 'function') {
            window.fbq('track', eventName, fbPayload);
        }

        // Clear datalayer
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            'event': 'transaction',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': payload.transaction_id,
                        'affiliation': 'Play Virtuoso',
                        'revenue': payload.amount,
                        'shipping': 0
                    },
                    'products': [ // List of productFieldObjects.
                        {
                            'name': type + ': ' + payload.name, // Name or ID is required.
                            'id': payload.item_id,
                            'price': payload.amount,
                            'brand': 'Play Virtuoso',
                            'category': payload.category,
                            'quantity': 1
                        }
                    ]
                }
            }
        });
    }
}

export { globalEventFire };
